import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelAutoCompleteWithRefInput
} from "../FormSectionComponents";

const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class CashManagementChildSection extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <div id="covenants_section_cash_management">
        <ChildSectionTitle>Cash Management</ChildSectionTitle>
        <StyledGrid container alignItems="center" direction="column">

          <SideLabelTextAreaWithRefInput label="Cash Management Event" hasBorder placeholder="Cash Management Event" fieldName="covenants.cashSweepConditions" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Cash Management Account" hasBorder placeholder="Cash Management Account" fieldName="covenants.cashSweepAccount" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Application of Funds" hasBorder placeholder="Application of Funds" fieldName="covenants.applicationOfFunds" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Cash Management Cure" hasBorder placeholder="Cash Management Cure" fieldName="covenants.cashManagementCure" isDisabled={!isEditing} />
          <SideLabelTextAreaWithRefInput label="Misc." placeholder="Misc." fieldName="covenants.cashManagementMisc" isDisabled={!isEditing} />

        </StyledGrid>
      </div>
    );
  }
}
export default CashManagementChildSection;
